'use client';

import { useEffect, useRef } from 'react';
import { CLIENT_VERSION_INFO } from '@/lib/version-client';
import { Logger } from '@/lib/logger';

/**
 * Emits a single structured boot log with frontend VERSION_INFO.
 *
 * Mounted once by the root layout. Deduplicates across React strict-mode
 * double-mounts in development using a module-scoped flag.
 */
let bootLogged = false;

export function VersionBootLogger() {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current || bootLogged) {
      return;
    }
    hasRun.current = true;
    bootLogged = true;

    Logger.info('Frontend started', {
      ...CLIENT_VERSION_INFO,
      url: typeof window !== 'undefined' ? window.location.href : undefined,
    });
  }, []);

  return null;
}
